export default "/assets/images/pollen-video-thumbnail.cfc13993ae42c355.jpg";